import { addNextUrlForQuery } from 'utils/url-query-params/url-query-params';

export const isSsoLoginSourcePage = () => window.location.href.includes('signin-sso');

export const getUrlToForceSso = (
    username: string,
    accountResponse: string | undefined,
    nextUrl: string | null,
) => {
    const ssoBasePath = `signin-sso?sso_email=${encodeURIComponent(
        username,
    )}&required_sso=true&account=${accountResponse}`;

    return addNextUrlForQuery(ssoBasePath, nextUrl);
};
